<template>
    <section>
        <div class="left">
            <h2 v-translate>URL obchodů</h2>
        </div>
        <div class="right">
            <text-input
                id="applestoreurl"
                v-model="entity.apple_store_url"
                ref="applestoreurlref"
                :disabled="!isEditable"
            ><translate class="translate">Apple store</translate>
            </text-input>
            <text-input
                id="googlestoreurl"
                v-model="entity.google_store_url"
                ref="googlestoreurlref"
                :disabled="!isEditable"
            ><translate class="translate">Google store</translate>
            </text-input>
            <text-input
                id="microsoftstoreurl"
                v-model="entity.microsoft_store_url"
                ref="microsoftstoreurlref"
                :disabled="!isEditable"
            ><translate class="translate">Microsoft store</translate>
            </text-input>
        </div>
    </section>
</template>

<script>
	export default {
		name: "ShopUrls",
		props: {
      isEditable: Boolean,
			entity: Object,
			errorMessages: {
				type: [Array, Object],
				default: function () {
					return []
				},
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/brands/forms/ShopUrls.vue